/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAssetType } from './ControlAssetType';
import {
    ControlAssetTypeFromJSON,
    ControlAssetTypeFromJSONTyped,
    ControlAssetTypeToJSON,
} from './ControlAssetType';
import type { ControlCategory6 } from './ControlCategory6';
import {
    ControlCategory6FromJSON,
    ControlCategory6FromJSONTyped,
    ControlCategory6ToJSON,
} from './ControlCategory6';
import type { ControlCategoryClass } from './ControlCategoryClass';
import {
    ControlCategoryClassFromJSON,
    ControlCategoryClassFromJSONTyped,
    ControlCategoryClassToJSON,
} from './ControlCategoryClass';
import type { ControlDateFilterDto } from './ControlDateFilterDto';
import {
    ControlDateFilterDtoFromJSON,
    ControlDateFilterDtoFromJSONTyped,
    ControlDateFilterDtoToJSON,
} from './ControlDateFilterDto';
import type { ControlIntegrationPlatform5 } from './ControlIntegrationPlatform5';
import {
    ControlIntegrationPlatform5FromJSON,
    ControlIntegrationPlatform5FromJSONTyped,
    ControlIntegrationPlatform5ToJSON,
} from './ControlIntegrationPlatform5';
import type { ControlOrderDir } from './ControlOrderDir';
import {
    ControlOrderDirFromJSON,
    ControlOrderDirFromJSONTyped,
    ControlOrderDirToJSON,
} from './ControlOrderDir';
import type { ControlSeverity7 } from './ControlSeverity7';
import {
    ControlSeverity7FromJSON,
    ControlSeverity7FromJSONTyped,
    ControlSeverity7ToJSON,
} from './ControlSeverity7';
import type { ControlStatus9 } from './ControlStatus9';
import {
    ControlStatus9FromJSON,
    ControlStatus9FromJSONTyped,
    ControlStatus9ToJSON,
} from './ControlStatus9';
import type { ControlVerdict8 } from './ControlVerdict8';
import {
    ControlVerdict8FromJSON,
    ControlVerdict8FromJSONTyped,
    ControlVerdict8ToJSON,
} from './ControlVerdict8';

/**
 * 
 * @export
 * @interface ControlSearchCasesDto
 */
export interface ControlSearchCasesDto {
    /**
     * 
     * @type {string}
     * @memberof ControlSearchCasesDto
     */
    assetId?: string;
    /**
     * 
     * @type {ControlAssetType}
     * @memberof ControlSearchCasesDto
     */
    assetType?: ControlAssetType;
    /**
     * 
     * @type {ControlCategory6}
     * @memberof ControlSearchCasesDto
     */
    category?: ControlCategory6;
    /**
     * 
     * @type {ControlCategoryClass}
     * @memberof ControlSearchCasesDto
     */
    categoryClass?: ControlCategoryClass;
    /**
     * 
     * @type {ControlDateFilterDto}
     * @memberof ControlSearchCasesDto
     */
    createdAt?: ControlDateFilterDto;
    /**
     * 
     * @type {number}
     * @memberof ControlSearchCasesDto
     */
    days?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchCasesDto
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchCasesDto
     */
    exclusionId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchCasesDto
     */
    filter?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlSearchCasesDto
     */
    groupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlSearchCasesDto
     */
    hideDemoClients?: boolean;
    /**
     * 
     * @type {ControlIntegrationPlatform5}
     * @memberof ControlSearchCasesDto
     */
    integrationPlatform?: ControlIntegrationPlatform5;
    /**
     * 
     * @type {boolean}
     * @memberof ControlSearchCasesDto
     */
    onlyChatOps?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlSearchCasesDto
     */
    onlyWasContained?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlSearchCasesDto
     */
    onlyWasEscalated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlSearchCasesDto
     */
    onlyWasMobile?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlSearchCasesDto
     */
    onlyWasMonitored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchCasesDto
     */
    orderBy?: string;
    /**
     * 
     * @type {ControlOrderDir}
     * @memberof ControlSearchCasesDto
     */
    orderDir?: ControlOrderDir;
    /**
     * 
     * @type {number}
     * @memberof ControlSearchCasesDto
     */
    page?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchCasesDto
     */
    search?: string;
    /**
     * 
     * @type {ControlSeverity7}
     * @memberof ControlSearchCasesDto
     */
    severity?: ControlSeverity7;
    /**
     * 
     * @type {number}
     * @memberof ControlSearchCasesDto
     */
    size?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlSearchCasesDto
     */
    startDate?: string;
    /**
     * 
     * @type {Array<ControlStatus9>}
     * @memberof ControlSearchCasesDto
     */
    statuses?: Array<ControlStatus9>;
    /**
     * 
     * @type {ControlVerdict8}
     * @memberof ControlSearchCasesDto
     */
    verdict?: ControlVerdict8;
}

/**
 * Check if a given object implements the ControlSearchCasesDto interface.
 */
export function instanceOfControlSearchCasesDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlSearchCasesDtoFromJSON(json: any): ControlSearchCasesDto {
    return ControlSearchCasesDtoFromJSONTyped(json, false);
}

export function ControlSearchCasesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSearchCasesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetId': !exists(json, 'assetId') ? undefined : json['assetId'],
        'assetType': !exists(json, 'assetType') ? undefined : ControlAssetTypeFromJSON(json['assetType']),
        'category': !exists(json, 'category') ? undefined : ControlCategory6FromJSON(json['category']),
        'categoryClass': !exists(json, 'categoryClass') ? undefined : ControlCategoryClassFromJSON(json['categoryClass']),
        'createdAt': !exists(json, 'createdAt') ? undefined : ControlDateFilterDtoFromJSON(json['createdAt']),
        'days': !exists(json, 'days') ? undefined : json['days'],
        'endDate': !exists(json, 'endDate') ? undefined : json['endDate'],
        'exclusionId': !exists(json, 'exclusionId') ? undefined : json['exclusionId'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
        'groupIds': !exists(json, 'groupIds') ? undefined : json['groupIds'],
        'hideDemoClients': !exists(json, 'hideDemoClients') ? undefined : json['hideDemoClients'],
        'integrationPlatform': !exists(json, 'integrationPlatform') ? undefined : ControlIntegrationPlatform5FromJSON(json['integrationPlatform']),
        'onlyChatOps': !exists(json, 'onlyChatOps') ? undefined : json['onlyChatOps'],
        'onlyWasContained': !exists(json, 'onlyWasContained') ? undefined : json['onlyWasContained'],
        'onlyWasEscalated': !exists(json, 'onlyWasEscalated') ? undefined : json['onlyWasEscalated'],
        'onlyWasMobile': !exists(json, 'onlyWasMobile') ? undefined : json['onlyWasMobile'],
        'onlyWasMonitored': !exists(json, 'onlyWasMonitored') ? undefined : json['onlyWasMonitored'],
        'orderBy': !exists(json, 'orderBy') ? undefined : json['orderBy'],
        'orderDir': !exists(json, 'orderDir') ? undefined : ControlOrderDirFromJSON(json['orderDir']),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'search': !exists(json, 'search') ? undefined : json['search'],
        'severity': !exists(json, 'severity') ? undefined : ControlSeverity7FromJSON(json['severity']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'startDate': !exists(json, 'startDate') ? undefined : json['startDate'],
        'statuses': !exists(json, 'statuses') ? undefined : ((json['statuses'] as Array<any>).map(ControlStatus9FromJSON)),
        'verdict': !exists(json, 'verdict') ? undefined : ControlVerdict8FromJSON(json['verdict']),
    };
}

export function ControlSearchCasesDtoToJSON(value?: ControlSearchCasesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assetId': value.assetId,
        'assetType': ControlAssetTypeToJSON(value.assetType),
        'category': ControlCategory6ToJSON(value.category),
        'categoryClass': ControlCategoryClassToJSON(value.categoryClass),
        'createdAt': ControlDateFilterDtoToJSON(value.createdAt),
        'days': value.days,
        'endDate': value.endDate,
        'exclusionId': value.exclusionId,
        'filter': value.filter,
        'groupIds': value.groupIds,
        'hideDemoClients': value.hideDemoClients,
        'integrationPlatform': ControlIntegrationPlatform5ToJSON(value.integrationPlatform),
        'onlyChatOps': value.onlyChatOps,
        'onlyWasContained': value.onlyWasContained,
        'onlyWasEscalated': value.onlyWasEscalated,
        'onlyWasMobile': value.onlyWasMobile,
        'onlyWasMonitored': value.onlyWasMonitored,
        'orderBy': value.orderBy,
        'orderDir': ControlOrderDirToJSON(value.orderDir),
        'page': value.page,
        'search': value.search,
        'severity': ControlSeverity7ToJSON(value.severity),
        'size': value.size,
        'startDate': value.startDate,
        'statuses': value.statuses === undefined ? undefined : ((value.statuses as Array<any>).map(ControlStatus9ToJSON)),
        'verdict': ControlVerdict8ToJSON(value.verdict),
    };
}

